
import { Options, Vue } from 'vue-class-component';
import { mapGetters } from 'vuex';
import store from '@/store';
import config from '@/config.json';

@Options({
  computed: {
    ...mapGetters(['getJsonData', 'isAuthenticated', 'currentUser']),
    showRegisterButton() {
      return config.showRegisterButton;
    },
    jsonData() {
      const jsonData = (this as any).getJsonData;
      const jsonDataWithBreaks = JSON.stringify(jsonData).replace(/\\n/g, '<br>');
      return JSON.parse(jsonDataWithBreaks);
    },
    displayName() {
      const user = (this as any).currentUser;
      if (!user) return '';
      return user.fullName || (user.email ? user.email.split('@')[0] : '');
    }
  },
  methods: {
    openAuth() {
      store.commit('SET_AUTH_MODAL', { visible: true, mode: 'register' });
    },
    logout() {
      store.dispatch('logoutUser');
    }
  }
})
export default class RegisterCta extends Vue {}
